module.exports = __webpack_public_path__ + "img/xlb1.308a6685.png";